import { ActionTypes as activeViewActions } from '../../actions/draftsAndOrders/activeViewActions';

const init = {
  activeType: 'paper',
  activeView: 'drafts',
};

const reducer = (state = init, action) => {
  switch (action.type) {
    // Drafts and Orders active views
    case activeViewActions.SET_ACTIVE_TYPE: {
      return {
        ...state,
        activeType: action.payload,
      };
    }
    case activeViewActions.SET_ACTIVE_VIEW: {
      return {
        ...state,
        activeView: action.payload,
      };
    }
    default:
      return state;
  }
};

export default reducer;
